import { Check, ToastSelection } from '@Types/toast';

export function getSelectionDisplayNames(order: {
  checks: { selections: ToastSelection[] }[];
}): string[] {
  return order.checks.flatMap((check) =>
    check.selections.map(
      (selection) =>
        selection.displayName ?? (selection.item as any)?.displayName ?? '',
    ),
  );
}

export function getPaymentTypes(checks?: Check[]): string[] {
  if (!checks || checks.length === 0) return [];

  const payments = checks.flatMap((check) => check.payments || []);
  const paymentTypes = payments.reduce((acc, payment) => {
    if (!acc.includes(payment.type)) {
      const type = payment.type === 'OTHER' ? 'STORKPAY' : payment.type;

      return [...acc, type];
    }

    return acc;
  }, [] as string[]);

  return paymentTypes;
}
